import * as React from 'react';
import { Button, Typography } from 'antd';
import { IWidget } from 'common/schema/widget/Widget';
import { QuillHtmlRenderView } from 'client/core/html/render/QuillHtmlRenderView';
const { Text, Paragraph } = Typography;

export interface WidgetInputUploadSignedUploadTextProps {
  previewOnly?: boolean;
  widget: IWidget;
}

export function WidgetInputUploadSignedUploadText(
  props: WidgetInputUploadSignedUploadTextProps
) {
  const { widget } = props;

  if (!widget.input?.extra?.uploadText) {
    return (
      <Paragraph>
        Per procedere all'inoltro dell'istanza, è necessario:
        <br />
        <ul>
          <li>in caso di firma digitale: scaricare e firmare digitalmente</li>
          <li>
            in caso di firma autografa: scaricare, stampare e firmare con firma
            autografa
          </li>
        </ul>
        Il documento dovrà poi essere caricato attraverso il seguente campo di
        caricamento file.
      </Paragraph>
    );
  }

  return <QuillHtmlRenderView content={widget.input.extra.uploadText} />;
}
